(function () {
  /**
   * JV to show and hide Pagefly sections by CSS Class
   *  e.x. add  'date-timer date-start-28-03-2023-18-00 date-stop-28-03-2023-22-00' to a PageFly Section
   *  DD-MM-YYYY-hh-mm
   *  date-start-28-02-2023-18-00
   *  date-stop-28-02-2023-22-00
   */

  /*
    createDateString
    to create a comparble timestamps
   */
  function createDateString(dateStringFromClassName) {
    var timeArray = dateStringFromClassName.split('-');
    var time = new Date(timeArray[2], timeArray[1] - 1, timeArray[0], timeArray[3], timeArray[4]);

    return time
  }

  /*
  extract the prefix "date-start" or "data-stop" from the class name "date-start-23-28-2023" to get the date string behind
  */
  function extractDateString(classNameString) {
    var classNameParts = classNameString.split('-');
    var prefix = classNameParts[0] + '-' + classNameParts[1];
    var dateString = classNameString.substring(prefix.length + 1);
    return dateString
  }

  const pageflySections = document.querySelectorAll('[data-pf-type="Section"]');

  for (var i = 0; i < pageflySections.length; i++) {

    if (pageflySections[i].classList.contains('date-timer') == true) {

      var classes = pageflySections[i].className.split(' ');

      for (var j = 0; j < classes.length; j++) {

        var className = classes[j];

        if (className.indexOf('date-start-') == 0) {
          var sExtractDateString = extractDateString(className);
          var startTime = createDateString(sExtractDateString);
        }

        if (className.indexOf('date-stop-') == 0) {
          var sExtractDateString = extractDateString(className);
          var stopTime = createDateString(sExtractDateString);
        }

        let currentTime = new Date();

        if (startTime < currentTime && stopTime > currentTime ) {
          pageflySections[i].style.display = 'block';
        } else {
          pageflySections[i].style.display = 'none';
        }
      }
    }
  }
})();
